// extracted by mini-css-extract-plugin
export var bounce = "_mj-1";
export var generatingText = "_mj-6";
export var lightning = "_mj-4";
export var popup = "_mj-5";
export var progressBar = "_mj-7";
export var progressFill = "_mj-8";
export var progressShimmer = "_mj-9";
export var progressText = "_mj-a";
export var shimmer = "_mj-3";
export var uploadIcon = "_mj-0";
export var uploadingText = "_mj-2";